// extracted by mini-css-extract-plugin
export default {"endDate":"HLXxYTYvKS"};